import { useEffect, useState, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  wsPostConfirmaCodigo,
  wsGetCambioClave,
  logoutPacienteDefault,
} from "../../../context/Actions/paciente/paciente";
import { showToaster } from "../../../../global/context/action/toaster/toaster.js";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import Temporizador from "../../Genericos/Temporizador/Temporizador";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { IonSpinner } from "@ionic/react";
import styled from "styled-components";
import TecladoAlfanumerico from "_+_Portal/components/Genericos/TecladoAlfanumerico/TecladoAlfanumerico";

// Layout styled-components
const PasoContainer = styled.div`
  width: 100%;
`;

const HeaderBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: clamp(12px, 2.5vw, 16px) clamp(16px, 3vw, 24px);
  background-color: var(--color-latex30);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const Title = styled.h1`
  margin: 0;
  color: var(--color-white);
  font-size: clamp(16px, 2.2vw, 20px);
  line-height: clamp(20px, 2.6vw, 24px);
`;

const Body = styled.div`
  width: 100%;
  padding: clamp(16px, 3vw, 24px);
`;

const Texto = styled.h3`
  margin: 0 0 8px 0;
  color: var(--color-latex10);
  font-weight: 400;
`;

const InputBox = styled.div`
  width: min(304px, 100%);
  height: 45px;
  margin: 20px auto 24px auto;
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const CodeButton = styled.button`
  width: min(220px, 48%);
  height: 45px;
  border-radius: 8px;
  background: var(--color-white);
  padding: 7px 16px;
  min-width: 120px;
  margin: 8px 0 24px 0;
  border: 1px var(--color-latex30) solid;
  box-shadow:
    0px 100px 80px rgba(0, 0, 0, 0.07),
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  color: var(--color-latex30);
  cursor: pointer;
  &:disabled {
    cursor: default;
    border-color: var(--color-grey45);
    background-color: var(--color-grey95);
    color: var(--color-grey45);
  }
`;

const SubmitButton = styled.button`
  width: min(220px, 48%);
  height: 45px;
  border-radius: 8px;
  background: var(--color-broccoli);
  color: var(--color-white);
  border: none;
  padding: 7px 16px;
  min-width: 120px;
  margin: 8px 0 24px 0;
  box-shadow:
    0px 100px 80px rgba(0, 0, 0, 0.07),
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
`;

// Teclado wrapper local
const TecladoWrapper = styled.div`
  width: 100%;
  padding: 20px 0;
  background-color: var(--color-latex10);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TecladoInner = styled.div`
  width: 1040px;
  max-width: 95vw;
  overflow: visible;
`;

const CambioPasswordPaso2 = ({
  dissmiss,
  texto,
  pathModal,
  pasoModal,
  navigateTo,
}) => {
  const { modalDispatch, registroState, pacienteState, pacienteDispatch } =
    useContext(PortalContext);

  // contexto global del Toaster
  const { toasterDispatch } = useContext(GlobalContext);

  const [disable, setDisable] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [error, setError] = useState(false);

  // Mostrar teclado solo en tablet/desktop
  const [isTabletOrDesktop, setIsTabletOrDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 768 : true,
  );
  useEffect(() => {
    const onResize = () => setIsTabletOrDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Track foco local
  const [activeInputName, setActiveInputName] = useState("codigoSeguridad");
  useEffect(() => {
    const onFocusIn = (e) => {
      const t = e.target;
      if (t && t.tagName === "INPUT" && t.name) setActiveInputName(t.name);
    };
    document.addEventListener("focusin", onFocusIn);
    return () => document.removeEventListener("focusin", onFocusIn);
  }, []);

  useEffect(() => {
    document.getElementsByName("codigoSeguridad")[0].focus();
    setDisable(true);
  }, []);

  const reenviarEmail = () => {
    let dni = registroState.registro.usuario.nro_documento;
    wsGetCambioClave(dni, changePaso)(pacienteDispatch);
    setDisable(true);
    showToaster(
      {
        texto: "Enviamos nuevamente el código a su casilla de Email.",
        tipo: "success",
      },
      "centroArriba",
    )(toasterDispatch);
  };

  const onChangeTemporizador = () => {
    setDisable(false);
  };

  const isEmptyError = (empty) => {
    if (empty === "") {
      return true;
    }
    return false;
  };

  const checkCodigo = () => {
    const domValue = (
      document.getElementsByName("codigoSeguridad")[0]?.value || ""
    ).toString();
    const current = (codigo || domValue || "").toString().toUpperCase();
    if (current !== "") {
      setCodigo(current);
      wsPostConfirmaCodigo(current, changePaso)(pacienteDispatch);
    } else {
      showToaster(
        {
          texto:
            "El codigo que quiere Validar, es invalido. Por favor, complete el campo correctamente.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
    }
  };

  const onCodigoChange = (e) => {
    let errx = false;
    errx = isEmptyError(e.target.value);
    setError(errx);
    setCodigo(e.target.value);
  };

  const changePaso = (isCorrect, data, codigo) => {
    if (isCorrect) {
      if (data !== null && data !== undefined && data?.idPaciente > 0) {
        hideModal()(modalDispatch);
        showToaster(
          {
            texto: "Código validado correctamente",
            tipo: "success",
          },
          "centroArriba",
        )(toasterDispatch);
        showModal(
          "Auth/CambioPassword/CambioPasswordPaso3",
          {
            titulo: "Creá una contraseña nueva",
            token: codigo,
            dissmiss: dissmiss,
            pathModal: pathModal,
            pasoModal: pasoModal,
            navigateTo: navigateTo,
          },
          {},
          "centro",
          true,
        )(modalDispatch);
      }
    } else {
      if (
        data !== null &&
        data !== undefined &&
        data.status === 400 &&
        data.data !== ""
      ) {
        let texto = data?.data?.detail;
        showToaster(
          {
            texto: texto,
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
      } else if (
        data !== null &&
        data !== undefined &&
        data.status !== 400 &&
        data !== false
      ) {
        showToaster(
          {
            texto:
              "Su código no pudo ser verificado, contáctese con el centro de atención al paciente",
            tipo: "danger",
          },
          "centroArriba",
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      }
    }
  };

  // Escribir con teclado en input activo
  const updateActiveInputValue = (newValue) => {
    const name = activeInputName || "codigoSeguridad";
    const el = document.getElementsByName(name)[0];
    if (!el) return;
    const maxLen = typeof el.maxLength === "number" ? el.maxLength : -1;
    const finalValue =
      maxLen > -1 && newValue.length > maxLen
        ? newValue.slice(0, maxLen)
        : newValue;
    if (document.activeElement !== el) el.focus();
    el.value = finalValue;
    try {
      const inputEvt = new InputEvent("input", { bubbles: true });
      el.dispatchEvent(inputEvt);
    } catch (e) {
      el.dispatchEvent(new Event("input", { bubbles: true }));
    }
    el.dispatchEvent(new Event("change", { bubbles: true }));
  };
  const handleKeyboardChange = (value) => {
    if (typeof value !== "string") return;
    updateActiveInputValue(value);
  };
  const handleKeyboardDelete = () => {
    const name = activeInputName || "codigoSeguridad";
    const el = document.getElementsByName(name)[0];
    if (!el) return;
    const current = el.value || "";
    updateActiveInputValue(current.slice(0, -1));
  };

  const handleKeyboardEnter = () => {
    checkCodigo();
  };

  return (
    <>
      <PasoContainer>
        <HeaderBar>
          <Title>Ingresá el token que te enviamos por correo</Title>
          <div className="cruz" onClick={dissmiss}>
            <div className="cruzParte1"></div>
            <div className="cruzParte2"></div>
          </div>
        </HeaderBar>
        <Body>
          <Texto>
            Ingresá el token que te enviamos por correo electrónico. Si no lo
            ves en tu bandeja de entrada, revisá el correo no deseado (spam).
          </Texto>
          <Texto>{texto === "" ? "" : texto}</Texto>
          <InputBox>
            <InputV1
              name="codigoSeguridad"
              headerStr="Escribí el token de seguridad"
              placeholderText="H92KIYG"
              inputType="text"
              onChange={onCodigoChange}
              errorStr="El código es inválido"
              className="rb16m"
              maxLength="6"
              value={codigo}
              checkError={error}
              isRequired={true}
            />
          </InputBox>
          <ActionsRow>
            <CodeButton onClick={() => reenviarEmail()} disabled={disable}>
              {disable ? (
                <Temporizador onChange={onChangeTemporizador} />
              ) : (
                "Reenviar mail"
              )}
            </CodeButton>
            <SubmitButton onClick={() => checkCodigo()}>
              {pacienteState.paciente.loading ? (
                <IonSpinner name="lines-small" />
              ) : (
                "Validar token"
              )}
            </SubmitButton>
          </ActionsRow>
        </Body>
      </PasoContainer>

      {isTabletOrDesktop && (
        <TecladoWrapper>
          <TecladoInner>
            <TecladoAlfanumerico
              sinNumeros={false}
              modeLight={true}
              onEnter={handleKeyboardEnter}
              enterStr={"Enter"}
              onChange={handleKeyboardChange}
              maxLength={6}
              onDelete={handleKeyboardDelete}
            />
          </TecladoInner>
        </TecladoWrapper>
      )}
    </>
  );
};

export default CambioPasswordPaso2;
